(() => {
  if (window.hxTestimonialsLoaded) return;
  window.hxTestimonialsLoaded = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const controllers = new Map();
  const allStates = () => [...controllers.values()].flatMap(controller => controller.states);
  const labels = state => {
    state.player.dataset.playing = String(!state.video.paused);
    state.player.dataset.sound = String(!state.video.muted);
    state.soundButton.setAttribute('aria-label', state.video.muted ? state.root.dataset.unmuteLabel : state.root.dataset.muteLabel);
    state.soundButton.setAttribute('aria-pressed', String(!state.video.muted));
  };
  const allowed = state => state.visible && !document.hidden && !state.userPaused && (!reduced.matches || state.userStarted);
  const synchronize = state => {
    if (!allowed(state)) { state.video.pause(); labels(state); return; }
    if (!state.video.paused || state.pending) return;
    state.pending = true;
    Promise.resolve(state.video.play()).then(() => {
      if (!allowed(state)) state.video.pause();
    }).catch(() => {}).finally(() => { state.pending = false; labels(state); });
  };
  const mute = state => { state.video.muted = true; labels(state); };
  const initialize = scope => {
    scope.querySelectorAll('[data-hx-testimonials]').forEach(root => {
      if (controllers.has(root)) return;
      const states = [...root.querySelectorAll('[data-hx-review-player]')].map(player => {
        const video = player.querySelector('video');
        const state = {root, player, video, soundButton:player.querySelector('[data-hx-review-sound]'), visible:false, userPaused:false, userStarted:false, pending:false};
        video.muted = true; video.defaultMuted = true; video.playsInline = true;
        video.loop = true; video.controls = false; video.preload = 'none';
        ['play','pause','volumechange'].forEach(event => video.addEventListener(event, () => labels(state)));
        state.soundButton.addEventListener('click', () => {
          const enableSound = video.muted;
          if (enableSound) allStates().filter(other => other !== state).forEach(mute);
          video.muted = !enableSound;
          if (enableSound) { state.userStarted = true; state.userPaused = false; }
          synchronize(state); labels(state);
        });
        player.querySelector('[data-hx-review-controls]').hidden = false;
        labels(state);
        return state;
      });
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const state = states.find(item => item.player === entry.target);
          if (!state) return;
          state.visible = entry.isIntersecting && entry.intersectionRatio >= .35;
          if (!state.visible) mute(state);
          synchronize(state);
        });
      }, {threshold:[0,.35]});
      controllers.set(root, {states, observer});
      states.forEach(state => observer.observe(state.player));
      const track = root.querySelector('.hx-testimonials-track');
      const previous = root.querySelector('[data-hx-review-step="-1"]');
      const next = root.querySelector('[data-hx-review-step="1"]');
      if (previous && next) {
        const updateNavigation = () => {
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        };
        root.querySelectorAll('[data-hx-review-step]').forEach(button => button.addEventListener('click', () => {
          track.scrollBy({left: track.clientWidth * .8 * Number(button.dataset.hxReviewStep), behavior: reduced.matches ? 'auto' : 'smooth'});
        }));
        track.addEventListener('scroll', updateNavigation, {passive:true});
        updateNavigation();
      }
    });
  };
  document.addEventListener('visibilitychange', () => allStates().forEach(state => {
    if (document.hidden) mute(state);
    synchronize(state);
  }));
  window.addEventListener('pagehide', () => allStates().forEach(state => { state.video.pause(); mute(state); }));
  window.addEventListener('pageshow', () => allStates().forEach(synchronize));
  reduced.addEventListener('change', () => allStates().forEach(state => { state.userStarted = false; synchronize(state); }));
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((controller, root) => {
      if (event.target.contains(root)) { controller.states.forEach(state => state.video.pause()); controller.observer.disconnect(); controllers.delete(root); }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once:true});
  else initialize(document);
})();
